// extracted by mini-css-extract-plugin
module.exports = {"form":"Edit_form__1kwK0","left":"Edit_left__2TeYA","right":"Edit_right__1HyHf","bottom":"Edit_bottom__3EXmI"};